module.exports = __webpack_public_path__ + "media/svg-new/svg-exclam-5f69abc0.svg";